export default {
  "pl": {
    "profile": {
      "actions": {
        "changeEmail": "Zmień adres e-mail",
        "changeEmailAddress": "Zmień adres e-mail",
        "delete": "Usuń",
        "save": "Zapisz"
      },
      "attributes": {
        "decimal_separator": "Zapis waluty dziesiętnej",
        "email_address": "E-mail",
        "email_address_new": "Nowy adres e-mail",
        "email_address_old": "Poprzedni adres e-mail"
      },
      "labels": {
        "allowAccess": "Udziel Ziggu dostępu do swojego konta",
        "allowImpersonation": "Zezwól na dostęp Ziggu",
        "allowImpersonationSubtext": "Być może będziemy potrzebowali tymczasowego dostępu do twojego konta, aby zdiagnozować i rozwiązać problem zgłoszony przez ciebie do działu obsługi klienta. Nasz dostęp automatycznie wygaśnie po upływie 7 dni.",
        "allowRecording": "Zezwól na rejestrację sesji",
        "allowRecordingSubtext": "Rejestrowanie twojej sesji na platformie Ziggu może pomóc nam w znalezieniu podstawowej przyczyny zgłoszonego przez ciebie problemu. Rejestracja zostanie automatycznie zatrzymana po upływie 60 minut lub w dowolnym momencie po wyłączeniu tej opcji.",
        "changeEmailAddress": "Zmień adres e-mail profilu: {profile_name}",
        "checkYourInbox": "Wysłaliśmy wiadomość e-mail z prośbą o potwierdzenie na następujący adres: {email_address}",
        "confirmEmailUpdate": "Wiadomość zawiera odnośnik, który należy kliknąć, aby dokończyć aktualizację. W razie problemów skontaktuj się z nami.",
        "confirmPasswordReset": "Wysłaliśmy wiadomość e-mail z odnośnikiem umożliwiającym zresetowanie hasła. Sprawdź skrzynkę odbiorczą. W razie problemów skontaktuj się z nami.",
        "currency": {
          "comma": "Przecinek: 200.450,99",
          "point": "Punkt: 200,450.99"
        },
        "delete_info": "Czy na pewno chcesz usunąć tego użytkownika? Ta akcja usunie wszystkie poufne dane użytkownika i zablokuje użytkownikowi możliwość dalszego logowania się i otrzymywania e-maili",
        "delete_user": "Usuń {user_name}",
        "emailAddressNewConfirm": "Potwierdź nowy adres e-mail",
        "emailNotificationsInterval": "Częstotliwość otrzymywania wiadomości e-mail dotyczących nowych powiadomień",
        "emailNotificationsIntervalSubtext": "Tutaj możesz określić, jak często mamy sprawdzać twoje nowe powiadomienia i informować cię o nich za pomocą wiadomości e-mail.",
        "explainerSendEmail": "Nowa wiadomość e-mail z zaproszeniem zostanie wysłana do: {name}",
        "explainerUpdateEmailActive": "Użytkownik {name} jest już aktywny na platformie. Wiadomość e-mail z potwierdzeniem zostanie wysłana na nowy adres.",
        "explainerUpdateEmailInvited": "Użytkownik {name} został już zaproszony. Nowa wiadomość z zaproszeniem zostanie wysłana na nowy adres e-mail. Wszystkie poprzednio wysłane zaproszenia wygasną.",
        "impersonateProfile": "Impersonate {profile_name}",
        "maintainerCannotImpersonatePartner": "Tylko członkowie zespołu pełniący rolę właściciela mogą podszywać się pod partnerów",
        "maintainerCannotUpdateEmailAddress": "Tylko członkowie zespołu pełniący rolę właściciela mogą zaktualizować adres e-mail",
        "multipleProfiles": "Ten użytkownik ma wiele profili na platformie Ziggu. Tylko użytkownik może zmienić ten adres e-mail.",
        "noEmailAddressAdded": "Nie dodano adresu e-mail",
        "redirectAutomatically": "Przekierowanie automatyczne nastąpi za {seconds} s",
        "requestPasswordReset": "Zresetuj hasło",
        "updateEmailFailed": "Nie udało się zaktualizować adresu e-mail. Spróbuj ponownie lub skontaktuj się z nami.",
        "updateEmailSuccessful": "Twój adres e-mail został zaktualizowany",
        "writeProfileNameReject": "Napisz <i><b>{profile_name}</b></i>, aby kontynuować."
      },
      "notifications": {
        "avatarChangedSuccessfully": "Awatar został zaktualizowany. Zmiany będą widoczne w ciągu godziny."
      },
      "toasts": {
        "emailResendSuccessfully": "Wiadomość została wysłana ponownie"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "Taki adres e-mail nie istnieje. Podaj poprawny adres.",
          "isp_block": "Blokada dostawcy usług internetowych: nasz adres IP lub serwer został odrzucony przez serwer poczty elektronicznej odbiorcy.",
          "soft_bounce": "Dana osoba znajduje się poza biurem lub jej skrzynka pocztowa jest pełna i nie przyjmuje wiadomości e-mail.",
          "spam_complaint": "Dana osoba skorzystała z opcji „oznacz jako spam” w swoim kliencie poczty elektronicznej, dezaktywując ten adres e-mail. Jeśli odbiorca nawiąże z tobą kontakt i wyrazi chęć ponownego otrzymywania wiadomości, skontaktuj się z nami.",
          "spam_notification": "Wiadomości e-mail zostały odrzucone przez serwer poczty elektronicznej. Być może stało się tak, ponieważ na serwerze odbiorcy obowiązują restrykcyjne zasady narzucone przez daną firmę, lub ponieważ w wiadomościach zawarto sformułowania odrzucane przez filtry antyspamowe."
        },
        "emailAddressBounced": "Błąd adresu e-mail",
        "emailDoesntMatch": "Niezgodny adres e-mail",
        "emailTaken": "Ten adres e-mail jest już w użyciu. Jeśli mimo to chcesz wprowadzić tę zmianę, skontaktuj się z nami za pośrednictwem czatu.",
        "mustBeEmailAddress": "Należy podać poprawny adres e-mail",
        "requireEmailAddress": "Należy podać adres e-mail",
        "tooManyRequests": "Adres e-mail można zmienić tylko raz na 5 minut. Spróbuj ponownie później."
      }
    }
  }
}
